import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../models/api.model';
import { ServiceCharge } from '../models/service-charge.model';

@Injectable()
export class ServiceChargesService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiURl}/bo/service-charges`;

  getServiceCharges(): Observable<ApiResponse<ServiceCharge[]>> {
    return this.http.get<ApiResponse<ServiceCharge[]>>(this.apiUrl);
  }

  createOrUpdateServiceCharge(
    serviceCharges: ServiceCharge[]
  ): Observable<ApiResponse<ServiceCharge[]>> {
    return this.http.post<ApiResponse<ServiceCharge[]>>(this.apiUrl, {
      serviceCharges,
    });
  }
}
